<div class="block-bottom-actions">
    <div class="inner">
        <a *ngIf="backAdress || isCallback" (click)="goBack()" href="#" class="btn btn-primary btn-back"><span>Retour</span></a>
    </div>
</div>
